import React, { useEffect, useState } from 'react';
import { Control } from 'react-hook-form';
import { Col } from 'reactstrap';
import { JobRequisitionDto } from '../../../../../../../services/applicant_tracking/JobRequisitionService/CreateJobRequisitionDto';
import { LabelledSelectFormHook } from '../../../../../../../components/LabelledSelectFormHook';
import { UserService } from '../../../../../../../services/v1/UserService';
import { UserList } from '../../../../../../../entities/v1/User';

interface PropTypes {
  formControl: Control<JobRequisitionDto>;
}

export function HiringManager(props: PropTypes) {
  const required = true;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    UserService.list({ ignorePagination: true }).then((response: UserList) => {
      setOptions(
        response.users.map((user) => ({
          label: user.name,
          value: user.id.toString(),
        })),
      );
    });
  }, []);

  return (
    <Col xs={3}>
      <LabelledSelectFormHook<JobRequisitionDto>
        label='Hiring Manager'
        placeholder='Select Hiring Manager'
        formHookContext={{
          controllerName: 'hiringManagerUserId',
          formControl: props.formControl,
          required: required,
        }}
        options={options}
      />
    </Col>
  );
}
